import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient , useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { companyClientgetInfo , companyClientShareholder,
  companyClientIndiceByComp , companyClientPeerByComp ,
  companyClientQtrresult , companyClientFinRatios ,
  companyClientBalanceSheet ,companyClientCashFlow,
  companyClientSectorByComp , companyClientProfitNloss ,
  companyClientChartData , companyClientDefaultratioData ,
  compFollowClientSave , 
  companyClientChartOtherData , 
  companyClientAnalysis ,
  getSmeDetails , 
  getSuperInvestorDetails , 
  companyClientInvestorySh , 
  companyClientAllCompany , 
  demoPortfolioClientSave ,
  getPortfolioDetails, 
  companyClientPortfolioSingle , 
  companyClientAdvdisadv,
  companyClientAdvdisadvnew,
  getSmeSectorDetails,
 } from './client/company';
import {useNavigate,Link} from "react-router-dom";

import { mapPaginatorData } from '../utils/data-mappers';
import { Routes } from '../routes/routes';
//import { Config } from '@/config';


export const useCompanyQuery = ({ slug }) => {
  console.log("params", slug);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/bysymbol/', slug],
    queryFn: () => companyClientgetInfo.get({ id:slug }),
  });
  return {
    product: data?.data,
    companymainLabelsList:data?.companymainLabelsList ? data?.companymainLabelsList : [],
    isFollowed:data?.isFollowed??false,
    error,
    isLoading,
  };
};


export const useCompanyQueryShareHolder = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_sharepattern/', id],
    queryFn: () => companyClientShareholder.get({ id:id }),
    enabled: !!id, // <— run only when id exists
  });
    console.log("data",data);
      //'formate_year'=>$formate_year,
    //

  return {
    companyshareholder: data?.data ? data.data : {},
    total_shareholder: data?.total_shareholder ? data.total_shareholder : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    start_year:data?.start_year ? data?.start_year: null,
    error,
    isLoading,
  };
};



export const useCompanyQueryIndicesByComp = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_indices_bycompId/', id],
    queryFn: () => companyClientIndiceByComp.get({ id:id }),
    enabled: !!id, // <— run only when id exists
  });
    console.log("data",data);
            
  return {
    indicesofcomp: data?.data ? data.data : {},
    error,
    isLoading,
  };
};



export const useCompanyQueryPeerByComp = (id) => {
  console.log("params", id);
  const { data, error, isLoading , refetch } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_peer_bycompId/', id],
    queryFn: () => companyClientPeerByComp.get({ id:id }),
    enabled: !!id, // <— run only when id exists
  });
    console.log("data",data);
            
  return {
    peerofcomp: data?.data ? data.data : {},
    error,
    isLoading,
    lable_array:data?.lable_array? data?.lable_array:[],
    refetch
  };
};

export const useCompanyQueryQtrResult = (params) => {
  console.log("params QR", params);
  const { data, error, isLoading ,isFetching ,refetch } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_quarterlyresult/', params?.id],
    queryFn: () => companyClientQtrresult.get({ id:params?.id , type:params?.type,
       company_type:params?.company_type 
     }),
  });
    console.log("data",data);
            //'formate_year'=>$formate_year,
    //

  return {
    quarterlyresult: data?.data ? data.data : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    lable_array:data?.lable_array? data?.lable_array:[],
    error,
    isLoading,
    refetch,
  };
};


export const useCompanyFinRatios = (params) => {
  console.log("params QR", params);
  const { data, error, isLoading ,refetch } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_finratios/', params?.id],
    queryFn: () => companyClientFinRatios.get({ id:params?.id , type:params?.type , company_type:params?.company_type }),
  });
    console.log("data",data);
    
  return {
    quarterlyresult: data?.data ? data.data : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    lable_array:data?.lable_array? data?.lable_array:[],
    error,
    isLoading,
    refetch
  };
};


export const useCompanyBalanceSheet = (params) => {
  //console.log("params QR", params);
  const { data, error, isLoading ,refetch } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_balancesheet/', params?.id],
    queryFn: () => companyClientBalanceSheet.get({ id:params?.id , type:params?.type , company_type:params?.company_type  }),
  });
  //console.log("data",data);
  return {
    balancesheet: data?.data ? data.data : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    lable_array:data?.lable_array? data?.lable_array:[],
    error,
    isLoading,
    refetch
  };
};

export const useCompanyCashflow = (params) => {
  //console.log("params QR", params);
  const { data, error, isLoading ,refetch } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_cashflow/', params?.id],
    queryFn: () => companyClientCashFlow.get({ id:params?.id , type:params?.type , 
      company_type:params?.company_type
     }),
  });
  //console.log("data",data);
  return {
    balancesheet: data?.data ? data.data : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    lable_array:data?.lable_array? data?.lable_array:[],
    error,
    isLoading,
    refetch
  };
};


export const useCompanyQuerySectorByComp = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_sector_bycompId/', id],
    queryFn: () => companyClientSectorByComp.get({ id:id }),
    enabled: !!id, // <— run only when id exists
  });
  
  console.log("data",data);
  return {
    sectorofcomp: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyQueryAnalysis = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/getanalysisdata/', id],
    queryFn: () => companyClientAnalysis.get({ id:id }),
    enabled: !!id, // <— run only when id exists
  });
  
  console.log("data",data);
  return {
    technicalanalysis: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyQueryAdvdisadv = (params) => {
  console.log("params company_type", params?.company_type);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/advdisadvantage/', params?.id],
    queryFn: () => companyClientAdvdisadv.get({ id:params?.id, company_type: params?.company_type }),
    enabled: !!params?.id, // <— run only when id exists
  });

  console.log("data",data);
  return {
    advdisadvdata: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyQueryAdvdisadvnew = (params) => {
  console.log("params company_type", params?.company_type);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/advdisadvantagenew/', params?.id],
    queryFn: () => companyClientAdvdisadvnew.get({ id:params?.id, company_type: params?.company_type }),
    enabled: !!params?.id, // <— run only when id exists
  });

  console.log("data",data);
  return {
    advdisadvdata: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyProfitNLoss = (params) => {
  console.log(" PORFIT LOSS params QR", params);
  const { data, error, isLoading ,refetch ,isFetching } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_profitNloss/', params?.id],
    queryFn: () => companyClientProfitNloss.get({ id:params?.id , type:params?.type, 
      company_type:params?.company_type }),
  });
  //console.log("data",data);
  return {
    profitNloss: data?.data ? data.data : {},
    years_list:data?.formate_year ? data?.formate_year :[],
    lable_array:data?.lable_array? data?.lable_array:[],
    error,
    isLoading,
    refetch,
  };
};

export const useCompanyHistoricalData = (params) => {
  console.log("params QR HS", params);
  const { data, error, isLoading ,isFetching } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_chartdata/', params],
    queryFn: () => companyClientChartData.get({ id:params}),
  });
  console.log("data",data);
  return {
    historicaldata: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyChartotherData = (params) => {
  console.log("params QR HS", params);
  const { data, error, isLoading ,isFetching } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_chartother/', params],
    queryFn: () => companyClientChartOtherData.get({ id:params}),
  });
  console.log("data",data);
  return {
    chartdataOther: data?.data ? data.data : {},
    error,
    isLoading,
  };
};


export const useCompanyDefaultRatioData = (params) => {
  console.log("params QR HS", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_company_default_ratios/', params],
    queryFn: () => companyClientDefaultratioData.get({ id:params}),
  });
  console.log("data",data);
  return {
    companydefaultratio: data?.data ? data.data : {},
    error,
    isLoading,
    companymainLabelsList:data?.companymainLabelsList ? data.companymainLabelsList : {},
  };
};



export const useSaveFollowMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn:compFollowClientSave.updatewithmultidata,
    onSuccess: () => {
      //toast.success(t('common:successfully-updated'));
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(API_ENDPOINTS.USERS);
    },
  });
};

export const useSaveDemoPFMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn:demoPortfolioClientSave.create,
    onSuccess: () => {
      //toast.success(t('common:successfully-updated'));
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(API_ENDPOINTS.USERS);
    },
  });
};


export const useSmeCompaniesQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SMEMARKET, params],
    queryFn: () => getSmeDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("sme market list data:", params, data);
  return {
    smedata: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    sector:data?.sector,
    tree: data?.tree,
    error,
    isLoading,
  };
};

export const useDemoPortfolioQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.GETALLDEMOPORTFOLIO, params],
    queryFn: () => getPortfolioDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("demo portfolio data:", params, data);
  return {
    demoportfoliodata: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};


export const useSuperInvestorsQuery = ( { limit , search } ) => {
  //console.log("params====", params);
  const {data,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
 } = useInfiniteQuery({
   queryKey: [API_ENDPOINTS.SUPERINVESTORS, limit, search],
    queryFn: ({pageParam = 1} ) => getSuperInvestorDetails.all( {page: pageParam,
        limit,search}),
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
     if (lastPage?.data?.length < limit) return undefined;
      return pages.length + 1;
    },
  });
  console.log("sme market list data:", limit, data);
  return {
    superinvestordata: data?.pages.flatMap(page => page.data) ?? [],
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};


export const useSuperInvestorQueryShdata = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.COMPANY + '/get_superinvestor_sh_new/', id],
    queryFn: () => companyClientInvestorySh.get(id),
    enabled: !!id, // <— run only when id exists
  });
   console.log("data super investor",data);
            
  return {
    superinvestorshdata: data?.data ? data.data : {},
    investorinfo : data?.investor ? data?.investor : {},
    error,
    isLoading,
  };
};

export const useDemoPortfolioQuerydata = (id) => {
  console.log("params", id);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.GETDEMOPORTFOLIOSINGLE + '/', id],
    queryFn: () => companyClientPortfolioSingle.get(id),
    enabled: !!id, // <— run only when id exists
  });
   console.log("data demo portfolio data single ",data);
            
  return {
    portfoliodatasingle: data?.data ? data.data : {},
    portfoli_info:data?.portfolio_info? data?.portfolio_info : {},
    error,
    isLoading,
  };
};




export const useAllCompanyQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.ALLCOMAPNIES, params],
    queryFn: () => companyClientAllCompany.all( params ),
    keepPreviousData: true,
  });
  //console.log("sme market list data:", params, data);
  return {
    allcompanies: data?.data,    
    error,
    isLoading,
  };
};



export const useSmeSectorQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SMESECTORS, params],
    queryFn: () => getSmeSectorDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("Sectors list data:", params, data);
  return {
    sectors: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    tree: data?.tree,
    error,
    isLoading,
  };
};













